import { useInfoAggiuntivaData, useInfoAggiuntivaIndex } from 'features/sport/hooks';

import { ScommesseEsitoTipoCard } from 'components/scommesseEsitoTipoCard';
import { ScommesseGridMultiple } from '../../wrappers/scommesseGridMultiple';
import styles from './Esito.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export interface RecursiveEsitoGridProps {
  scommessaKey: string;
  infoAggiuntivaKey: string;
  gtagAction?: () => void;
}

export const RecursiveEsitoGrid = ({ infoAggiuntivaKey, gtagAction }: RecursiveEsitoGridProps) => {
  const { t } = useTranslation();

  const infoAggData = useInfoAggiuntivaData(infoAggiuntivaKey);
  const { isBilanciata, valore, valoreTrKey } = infoAggData ?? {};

  const infoAggIndex = useInfoAggiuntivaIndex(infoAggiuntivaKey);
  const { esitoKeyList } = infoAggIndex ?? {};

  return (
    <ScommesseGridMultiple className={styles.noPadding}>
      <ScommesseGridMultiple.Row index={0}>
        {esitoKeyList?.map((key) => (
          <ScommesseEsitoTipoCard
            key={key}
            keyEsito={key}
            isBalanced={isBilanciata} // TODO : verificare se funziona
            backgroundType="secondary"
            additionalText={t(valoreTrKey, valore)}
            gtagAction={gtagAction}
          />
        ))}
      </ScommesseGridMultiple.Row>
    </ScommesseGridMultiple>
  );
};
